  console.log("totals_value");


if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;


      console.log("totals_value111");

      setTimeout(() => { 
        // window.location.reload();
      }, 3000);
      
      
      function form_totals() {

         
      }
     setTimeout(() => { 
              // form_totals();
      }, 1000);







  //      if (formData instanceof FormData) {
  // // 将 FormData 转换为一个可枚举的键值对
  // for (let [key, value] of formData.entries()) {
  //   console.log(`键: ${key}, 值: ${value}`);
  // }
  //   }
     
      
      let product_list = []
       // cookie 
      //    var products_handle = ['openfit-air','openfit','openswim','oepnswim-pro','openrun','openmove','openrun-pro','openrun-pro2']
      // let handle = this.form.querySelector("input.product-handle").value;
      //    if (products_handle.includes(handle)) {
      //      product_list.push( '45025487552834');
      //     } else {
      //       console.log("handle 不在数组中");
      //     }
         // cookie
      


      const product_form_dom = this.closest('.product-info').querySelector('product-info .sales-activities')
      if(product_form_dom){
        const product_items =  product_form_dom.querySelectorAll('.product-item')
         product_items?.forEach(item=>{
            if(item.getAttribute('data-choose')=="true"){
              product_list.push(item.getAttribute('data-product-id'))
            }
         })
      }
      

      

       const data = {
          items:[],
          sections: "cart-drawer,cart-icon-bubble",
        };
      
       if(product_list.length > 0){
         product_list.forEach(item=>{
           data.items.push({
              id:item,
              quantity: 1
           })
         })
        
         await fetch(`${routes.cart_add_url}`, {
           method: 'POST',
           headers: {
            'Content-Type': 'application/json'
           },
           body: JSON.stringify(data)
        })
      }
// cookie测试
//        function formDataToObject(formData) {
//   return Object.fromEntries(formData.entries());
// }
//       const obj = formDataToObject(formData);
//       // console.log(obj)
      
//       if(obj['product-id'] == '8290063450434'){
//         console.log('aaaaaaaaaaa')
//       }
//                 const cookieName = "visitedUrl";
//                 // 读取 Cookie 并打印
//                 const savedCookie = document.cookie
//                     .split('; ')
//                     .find(row => row.startsWith(`${cookieName}=`))
//                     ?.split('=')[1];

//                 if (savedCookie) {
//                     const decodedUrl = decodeURIComponent(savedCookie); // 解码 URL
//                     console.log("Saved URL in Cookie:", decodedUrl);
//                 } else {
//                     console.log("No URL found in Cookie.");
//                 }


     
// cookie测试
       fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });

      
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
